/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット開始前のユーザ選択パネル
 *
 * @author jimu
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-user-certificate-select-pane">

  <el-main class="main-area">
    <p class="information-text">{{$t('ご利用いただきありがとうございます。')}}<br>{{$t('以下ボタンを選択してください。')}}</p>
    <div class="user-certificate-button-body">
      <el-button type="primary" class="user-certificate-button" @click="doUserCertificate">{{$t('サービスをご利用中のお客様')}}</el-button>
    </div>
     <p class="webform-text"><br>{{$t('接続トラブルに関しては、以下WEBフォームからお問い合わせ下さい。')}}</p><p class="webform-text2"><a href="https://support.sonynetwork.co.jp/faqsupport/nuromansion/web/form140.html" target="blank" style="color:red;text-decoration:none;">→→→こちら←←←</a></p><p class="webform-text">{{$t('（例）')}}<br>{{$t('・インターネット接続ができない')}}<br>{{$t('・通信が不安定')}}<br>{{$t('・通信速度が遅い')}}</p>
     </el-main>
</el-container>
</template>

<script>
import {
  Container,
  Main,
  Button
} from 'element-ui'

export default {
  name: 'FcChatJoinPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-button': Button
  },
  methods: {
    /**
     *  サービスをご利用中のお客様を選択
     * @param  {Function} callback
     */
    doUserCertificate() {
      this.$emit('openUserCertificate')
    },
    /**
     *  お申し込み前のお客様を選択
     */
    doUserNoCertificate() {
      this.$emit('openUserNoCertificate')
    }
  }
}
</script>

<style scoped>
.fc-chat-user-certificate-select-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.user-certificate-button {
  width: 100%;
}

.user-certificate-button-body {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatUserCertificateSelect/FcChatUserCertificateSelectPane.vue